/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
/**
* CSS Custom Properties
*
* These properties can be overridden using the component's tag as selector.
*
* @prop --calcite-tip-manager-height: The maximum height of the component.
* @prop --calcite-tip-max-width: The maximum width of a slotted `calcite-tip` within the component.
*/
:host {
  box-sizing: border-box;
  display: block;
  background-color: var(--calcite-color-foreground-1);
  font-size: var(--calcite-font-size--1);
  line-height: 1rem;
  color: var(--calcite-color-text-2);
  --calcite-tip-manager-height: 19vh;
}
:host * {
  box-sizing: border-box;
}

:host([closed]) {
  display: none;
}

/* Shared styles for header elements */
.header {
  margin: 0px;
  display: flex;
  align-content: space-between;
  align-items: center;
  fill: var(--calcite-color-text-2);
  color: var(--calcite-color-text-2);
}

.heading {
  margin: 0px;
  padding: 0px;
  font-weight: var(--calcite-font-weight-medium);
}

.header .heading {
  flex: 1 1 auto;
  padding: 0.5rem;
}

.header {
  border-width: 0px;
  border-block-end-width: 1px;
  border-style: solid;
  border-color: var(--calcite-color-border-3);
  padding-block: 0px;
  padding-inline-end: 0px;
  padding-inline-start: 1rem;
}
.header .heading {
  padding: 0px;
  font-size: var(--calcite-font-size-1);
  line-height: 1.5rem;
  font-weight: var(--calcite-font-weight-bold);
  color: var(--calcite-color-text-1);
}

.container {
  position: relative;
  overflow: hidden;
  outline-color: transparent;
  min-block-size: 150px;
}
.container:focus {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}

.tip-container {
  margin-block-start: 1px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow: auto;
  padding: 1rem;
  outline-color: transparent;
  animation-name: none;
  animation-duration: var(--calcite-animation-timing);
  block-size: var(--calcite-tip-manager-height);
}
.tip-container:focus {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}

::slotted(calcite-tip) {
  margin: 0px;
  border-style: none;
  max-inline-size: var(--calcite-tip-max-width);
}

.tip-container--advancing {
  animation-name: tip-advance;
}

.tip-container--retreating {
  animation-name: tip-retreat;
}

/* Pagination Styles*/
.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-inline: 0px;
  padding-block: 0.75rem 0.5rem;
}

.page-position {
  margin-block: 0px;
  margin-inline: 0.5rem;
  font-size: var(--calcite-font-size--2);
  line-height: 1rem;
}

/* @keyframes*/
@keyframes tip-advance {
  0% {
    opacity: 0;
    transform: translate3d(50px, 0, 0) scale(0.99);
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1);
  }
}
@keyframes tip-retreat {
  0% {
    opacity: 0;
    transform: translate3d(-50px, 0, 0) scale(0.99);
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1);
  }
}
:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}